import { render } from "./Edit.vue?vue&type=template&id=9c4b90de&ts=true"
import script from "./Edit.vue?vue&type=script&lang=ts"
export * from "./Edit.vue?vue&type=script&lang=ts"

import "./Edit.vue?vue&type=style&index=0&id=9c4b90de&lang=scss"

import exportComponent from "/home/runner/work/on-the-edge-admin/on-the-edge-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__